import { positions, width, height, extrudedHeight, cornerType, granularity } from '../mixinProps'

/**
 * vc-graphics-corridor base props mixins
 */
export default {
  mixins: [positions, width, height, extrudedHeight, cornerType, granularity]
}
